module.exports = __webpack_public_path__ + "img/upload_PDFreport.fe526838.svg";